import styled from "styled-components";

export const Container = styled.div<{
  maxHeight?: number;
  hideSearch?: boolean;
}>`
  display: flex;
  flex-direction: column;
  height: auto;
  @media ${({ theme }) => theme.devices.tablet} {
    overflow: hidden;
    max-height: ${({ maxHeight }) => `calc(${maxHeight}px)`};
    opacity: ${({ hideSearch }) => (hideSearch ? 0 : 1)};
    transition: max-height 0.4s ease, opacity 0.4s ease;
  }
`;

export const Label = styled.label`
  font-family: ${({ theme }) => theme.fonts.inter};
  color: ${({ theme }) => theme.colors.gray.dark};
  font-size: ${({ theme }) => theme.fontSize.mm};
  letter-spacing: 2px;
  font-weight: 600;
  padding-bottom: 10px;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  text-transform: capitalize;
  cursor: pointer;
  &::after {
    content: "";
    flex: auto;
  }
  font-family: ${({ theme }) => theme.fonts.inter};
  @media ${({ theme }) => theme.devices.tablet} {
    max-height: 200px;
    overflow-y: scroll;
    flex-wrap: nowrap;
    &::-webkit-scrollbar {
      display: none; /* Esconde a barra de rolagem no Chrome, Safari e Opera */
    }
    scrollbar-width: none;
  }
`;

export const ErrorMessage = styled.span`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: ${({ theme }) => theme.fontSizePx.smm};
  color: ${({ theme }) => theme.colors.red.normal};
  white-space: nowrap;
  margin-left: 0;
  margin-top: 20px;
  @media ${({ theme }) => theme.devices.tablet} {
    margin-top: 0px;
    margin-left: 0;
    text-align: right;
  }
`;
